"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Popover = {
  defaultProps: {
    hideTriangle: true
  },
  styles: function styles(theme) {
    return {
      root: {
        "--background": theme.colors.baseContrast010
      },
      content: {
        padding: theme.spacing.base,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: theme.colors.baseContrast020,
        borderRadius: 8
      },
      scroll: {
        "&::-webkit-scrollbar-thumb": {
          borderRadius: theme.spacing.base,
          border: "solid 1px ".concat(theme.colors.baseContrast020)
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: theme.colors.baseContrast010,
          borderRadius: 4
        }
      }
    };
  }
};
var _default = exports.default = Popover;